export class SelectedHost {
    hostId: string;
    page?: number;
    limit?: number;

    constructor(hostId: string, page?: number, limit?: number) {
        this.hostId = hostId;
        this.page = page || 1;
        this.limit = limit || 100;
    }
}
